import axios from 'axios';

// Development: http://localhost:5000/api
// Production: https://api.yourdomain.com/api (update with your actual domain)
export const API_BASE_URL = (process.env.REACT_APP_API_URL || 'http://localhost:5000/api').replace(/\/$/, '');
export const uploadsBaseUrl =
  process.env.REACT_APP_UPLOADS_URL ||
  `${API_BASE_URL.replace(/\/api\/?$/, '')}/uploads`;

const api = axios.create({
  baseURL: API_BASE_URL,
});

// Attach auth token to every request when available
api.interceptors.request.use(config => {
  const token = localStorage.getItem('fe_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

// Handle auth errors consistently
api.interceptors.response.use(
  response => response,
  error => {
    if (error.response?.status === 401) {
      localStorage.removeItem('fe_token');
      window.location.href = '/login';
    }
    return Promise.reject(error);
  }
);

export default api;
